module.exports = __webpack_public_path__ + "img/cuarto creciente.77d23a5e.svg";